import React, {Component} from 'react';
import LocalDate from '../LocalDate'
import PropTypes from 'prop-types';
import Moment from 'moment';
import 'moment/locale/it.js';
import { DatePicker } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';

import 'react-date-picker/index.css'
import '../../styles/GiornoSelect.css'

class GiornoSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewChoose: false,
            giorno: props.giorno,
        };
        this.onChange = this.onChange.bind(this)
        this.updateTime = this.updateTime.bind(this)
    }

    componentDidMount() {
        this.forceUpdateInterval = setInterval(() => this.updateTime(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.forceUpdateInterval);
    }

    updateTime(){
        //this.setState({giorno: '2017-06-01'});
        clearInterval(this.forceUpdateInterval);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.giorno !== this.state.giorno){
            this.setState({giorno: nextProps.giorno, viewChoose:false})
        }
    }

    onChange(dateString) {
        this.setState({giorno: dateString, viewChoose: false})
        if (this.props.onChange)
        {
            this.props.onChange(dateString);
        }
    }

    onModificaGiorno(ev){
        this.setState({viewChoose: true});
    }

    render() {
        let oggi=Moment().format('YYYY-MM-DD');
        if (this.state.viewChoose)
        {
            return (
            <div className="ui one small statistics">
                <div className="ui small statistic">
                    <div className="label">
                        Nuovo Giorno corrente:
                    </div>
                    <div className="ui one column center grid" >
                        <div className="column" style={{textAlign: "center"}}>
                            <DatePicker
                                onChange={(jsDate) => {this.onChange(Moment(jsDate).format('YYYY-MM-DD'))}}
                                value={this.state.giorno}
                                className="ui input"
                            />

                            {/*<Calendar*/}
                            {/*dateFormat="YYYY-MM-DD"*/}
                            {/*date={this.state.giorno}*/}
                            {/*onChange={this.onChange}*/}

                            {/*/>*/}
                        </div>
                    </div>

                </div>
            </div>
            )
        }

        if (this.state.giorno !== oggi){
            return (
                <div className="ui one tiny statistics">
                    <div className="ui tiny statistic">
                        <div className="label">
                            Giorno selezionato:
                        </div>
                        <div className="value fading-in-out">
                            <LocalDate data={this.state.giorno}/>
                        </div>
                        <div className="center aligned">
                            <a className="" href="#" onClick={(ev) => {this.onModificaGiorno(ev)}}>Modifica</a>
                            <a className="" href="#" onClick={() => {this.onChange(oggi)}}>&nbsp;/&nbsp;Vai a oggi</a>
                        </div>
                    </div>
                </div>
            )

        }

        return (
            <div className="ui one tiny statistics">
            <div className="ui tiny statistic">
                <div className="label">
                    Giorno selezionato:
                </div>
                <div className="value">
                    <LocalDate data={this.state.giorno}/>
                </div>
                <div className="center aligned">
                    <a className="" href="#" onClick={(ev) => {this.onModificaGiorno(ev)}}>Modifica</a>
                </div>
            </div>
            </div>
        )
    }
}

GiornoSelect.PropTypes = {
    giorno: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default GiornoSelect;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/GiornoSelect.jsx
 **/